import {
  CLEAR_FUNCIONARIO_ID,
  SET_FUNCIONARIO_ID
} from './types'

export const clearFuncionarioId = () => ({ type: CLEAR_FUNCIONARIO_ID });

export const setFuncionarioId = id => dispatch => dispatch({ type: SET_FUNCIONARIO_ID, payload: id });
